import { TicketDescription } from '@ticketmaster/global-design-system';
import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { T } from '@/v2/helpers/i18n';

const VoidedBarcode = ({ t }: T) => {
  return (
    <TicketDescription>
      <TicketDescription.Header icon="cancelled">
        <TicketDescription.Title>{t('WALLET.TICKETS.TICKET.INVALID_TICKET')}</TicketDescription.Title>
        <TicketDescription.Description>
          {t('WALLET.TICKETS.TICKET.INVALID_TICKET_FAN_SUPPORT')}
        </TicketDescription.Description>
      </TicketDescription.Header>
    </TicketDescription>
  );
};

export default withTranslation('translation')(memo(VoidedBarcode));
